import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isNotNullOrEmpty } from './utilities';

const ScrollToTop = () => {
  const location = useLocation();

  const pathname = location.pathname + location.search + location.hash;
  const hashpart = location.hash;

  useEffect(() => {
    if (isNotNullOrEmpty(hashpart)) {
      // Client-side route changes (via <Link>) don't get the browser's
      // native "scroll to the #hash element" behavior a full page load
      // would have given the old plain <a href="/#section"> anchors.
      const target = document.getElementById(hashpart.slice(1));
      target?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hashpart]);

  return null;
};

export default ScrollToTop;